module.exports = __webpack_public_path__ + "img/qureshia.c82e03ab.jpg";